"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryStruct = exports.InventoryProductStruct = exports.CategoryStruct = void 0;
const superstruct_1 = require("superstruct");
const curency_1 = require("./curency");
exports.CategoryStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.string)(), // name of the category
});
exports.InventoryProductStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.string)(),
    description: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    categoryId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    imageFile: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    isStockLimited: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    price: (0, superstruct_1.optional)((0, superstruct_1.number)()), // price of the product
});
exports.InventoryStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.string)(),
    color: (0, superstruct_1.string)(),
    categories: (0, superstruct_1.array)(exports.CategoryStruct),
    products: (0, superstruct_1.array)(exports.InventoryProductStruct),
    currency: curency_1.CurrencyStruct,
    isInventoryMaxOrder: (0, superstruct_1.defaulted)((0, superstruct_1.boolean)(), false),
    inventoryMaxOrder: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    stockCounters: (0, superstruct_1.optional)((0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.number)())), // counter that deplets the stock of a product
});
exports.CategoryStruct.type = 'Category';
exports.InventoryProductStruct.type = 'InventoryProduct';
exports.InventoryStruct.type = 'Inventory';
//# sourceMappingURL=inventory.js.map